import { BadgeCheck, Star } from "lucide-react";

const REVIEWS = [
  { name: "Sarah M.", text: "One on the ute chassis, one on the box trailer. Setup took under a minute in Find My and the magnet holds solid on the drawbar.", tag: "2 Tracksy" },
  { name: "Daniel K.", text: "Tucked it on the bracket behind the glovebox. Completely out of sight and the location refreshes every time I'm in town.", tag: "1 Tracksy" },
  { name: "Priya R.", text: "4-pack covers the car, the caravan, my bike and the toolbox. No subscription is what sold me.", tag: "4 Tracksy" },
  { name: "Tom W.", text: "Runs a landscaping crew — mowers, trailers, generators. Having a tag on each saves me phone calls every week.", tag: "8 Tracksy" },
  { name: "Elena G.", text: "Sits inside the mesh pocket of my suitcase. Watched it come off the carousel in Find My before I saw the bag.", tag: "2 Tracksy" },
  { name: "Marcus L.", text: "Metal sheet went on the inside of a plastic tool case and the holder snaps to it perfectly. Clever little kit.", tag: "1 Tracksy" },
  { name: "Hannah B.", text: "Support answered my pairing question within the hour. Clear about what it does and doesn't do, which I appreciated.", tag: "4 Tracksy" },
  { name: "James O.", text: "Spare wheel well in the sedan, under the seat in the van. Nobody would ever find them — I can.", tag: "2 Tracksy" },
];

const ReviewCard = ({ review }) => (
  <div className="w-[320px] shrink-0 rounded-3xl border border-white/10 bg-white/[0.06] p-6 backdrop-blur-sm sm:w-[380px]">
    <div className="flex items-center justify-between">
      <span className="flex text-tracksy-orange">
        {[...Array(5)].map((_, i) => (
          <Star key={i} className="h-4 w-4 fill-current" />
        ))}
      </span>
      <span className="rounded-full bg-white/10 px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-white/60">
        {review.tag}
      </span>
    </div>
    <p className="mt-4 text-sm leading-relaxed text-white/85">"{review.text}"</p>
    <div className="mt-4 flex items-center gap-2">
      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-tracksy-orange font-heading text-xs font-extrabold text-white">
        {review.name[0]}
      </span>
      <span className="text-sm font-bold text-white">{review.name}</span>
      <span className="flex items-center gap-1 text-xs text-tracksy-green">
        <BadgeCheck className="h-3.5 w-3.5" />
        Verified buyer
      </span>
    </div>
  </div>
);

const MarqueeRow = ({ reviews, reverse = false }) => (
  <div className="marquee-paused overflow-hidden">
    <div className={`flex w-max gap-5 py-2.5 ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}>
      {[...Array(2)].map((_, dup) => (
        <div key={dup} className="flex gap-5">
          {reviews.map((r, i) => (
            <ReviewCard key={`${r.name}-${i}`} review={r} />
          ))}
        </div>
      ))}
    </div>
  </div>
);

const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="noise-overlay scroll-mt-24 bg-tracksy-dark py-14 sm:py-20 lg:py-28">
    <div className="mx-auto mb-12 max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
        <div>
          <p className="mb-3 text-xs font-bold uppercase tracking-widest text-tracksy-orange">
            Reviews
          </p>
          <h2 className="font-heading text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Trusted on utes, trailers, toolboxes and suitcases.
          </h2>
        </div>
        <div data-testid="reviews-rating-summary" className="flex items-center gap-3 rounded-full border border-white/10 bg-white/5 px-5 py-2.5">
          <span className="flex text-tracksy-orange">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-4 w-4 fill-current" />
            ))}
          </span>
          <span className="text-sm font-bold text-white">Customer reviews</span>
          <span className="text-sm text-white/50">Verified purchases</span>
        </div>
      </div>
    </div>
    <div className="space-y-5">
      <MarqueeRow reviews={REVIEWS.slice(0, 4)} />
      <MarqueeRow reviews={REVIEWS.slice(4)} reverse />
    </div>
  </section>
);

export default Reviews;
